import {
  FGButton,
  FGIcons,
  IconsLarge,
  FGDropdownMenu,
  FGDropdownMenuListContent,
  FGDropdownMenuListItem,
  FGDropdownMenuDivider,
  FGDropdownMenuListAction,
} from '@fg/design-system';
import { useCallback, useState } from 'react';

type Props = {
  fullName: string;
};

export const UserProfile = ({ fullName }: Props) => {
  const [visible, setVisible] = useState(false);
  const show = useCallback(() => setVisible(true), []);
  const hide = useCallback(() => setVisible(false), []);

  const handleLogout = () =>
    fetch('/logout', {
      method: 'GET',
    })
      .then(() => {
        window.location.replace('/login');
      })
      .catch((error) => {
        console.error('Error:', error);
      });

  return (
    <>
      <FGDropdownMenu
        triggerElement={
          <FGButton variant="ghost" aria-label="User profile" onClick={visible ? hide : show}>
            <FGIcons large={IconsLarge.Profile} />
          </FGButton>
        }
        visible={visible}
        onClickOutside={hide}
      >
        <FGDropdownMenuListContent>
          <FGDropdownMenuListItem>
            <div className="fg-body4 fg-tc--weak">Signed in as:</div>
            <div className="fg-body3-short fg-tc--standard">{fullName}</div>
          </FGDropdownMenuListItem>
          <FGDropdownMenuDivider />
          <FGDropdownMenuListAction>
            <button
              className="pi-sign-out"
              style={{
                cursor: 'pointer',
                fontFamily: 'inherit',
                background: 'none',
                border: 0,
                padding: 0,
                textAlign: 'left',
              }}
              onClick={handleLogout}
            >
              Sign out
            </button>
          </FGDropdownMenuListAction>
        </FGDropdownMenuListContent>
      </FGDropdownMenu>
    </>
  );
};
